import React, { useState } from 'react';
import { contactApi } from '../services/api';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Button, Field, Card } from '../components/sv';
import { PageHero } from '../components/shared/PageHero';
import { OFFICES } from '../content/site';

const SUBJECTS = ['Get a quote', 'Existing booking', 'Bulk chartering', 'Account and approvals', 'Claims and insurance', 'Other'];

export default function ContactPage() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', company: '', phone: '', subject: '', message: '' });
  function handleChange(e) { setFormData(function (p) { return { ...p, [e.target.name]: e.target.value }; }); }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.subject || !formData.message) { toast.error('Fill in name, email, subject and message'); return; }
    setLoading(true);
    try {
      await contactApi.submit(formData);
      toast.success('Message sent. We reply within one business day.');
      setFormData({ name: '', email: '', company: '', phone: '', subject: '', message: '' });
    } catch (err) { toast.error('Could not send the message. Try again.'); } finally { setLoading(false); }
  }

  return (
    <div className="bg-white" data-testid="contact-page">
      <PageHero kicker="Contact" title="Talk to a person in your time zone" text="Sales, bookings, bulk chartering and claims. Regional teams answer within one business day." compact crumbs={[{ label: 'Contact' }]} />
      <div className="sv-wrap py-16 grid lg:grid-cols-12 gap-12">
        <Card className="lg:col-span-7" padding="p-8" data-testid="contact-form">
          <form onSubmit={handleSubmit} className="grid gap-5">
            <div className="grid sm:grid-cols-2 gap-5">
              <Field label="Name"><input name="name" value={formData.name} onChange={handleChange} className="sv-input" data-testid="contact-name" /></Field>
              <Field label="Email"><input type="email" name="email" value={formData.email} onChange={handleChange} className="sv-input" data-testid="contact-email" /></Field>
            </div>
            <div className="grid sm:grid-cols-2 gap-5">
              <Field label="Company"><input name="company" value={formData.company} onChange={handleChange} className="sv-input" data-testid="contact-company" /></Field>
              <Field label="Phone"><input name="phone" value={formData.phone} onChange={handleChange} className="sv-input sv-mono" data-testid="contact-phone" /></Field>
            </div>
            <Field label="Subject">
              <select name="subject" value={formData.subject} onChange={handleChange} className="sv-input" data-testid="contact-subject">
                <option value="">Select a subject</option>
                {SUBJECTS.map(function (s) { return <option key={s} value={s}>{s}</option>; })}
              </select>
            </Field>
            <Field label="Message"><textarea name="message" rows={6} value={formData.message} onChange={handleChange} className="sv-input h-auto py-3" data-testid="contact-message" /></Field>
            <div><Button type="submit" size="lg" disabled={loading} data-testid="contact-submit">{loading ? <Loader2 className="h-5 w-5 animate-spin" /> : 'Send message'}</Button></div>
          </form>
        </Card>
        <div className="lg:col-span-5 grid gap-6 content-start">
          {OFFICES.slice(0, 3).map(function (o) {
            return (
              <div key={o.city} className="border-t border-gray-200 pt-5">
                <p className="sv-kicker">{o.role}</p>
                <p className="text-xl mt-1">{o.city}, {o.country}</p>
                <p className="text-[15px] text-gray-700 mt-1">{o.address}</p>
                <a href={'mailto:' + o.email} className="sv-mono text-[15px] mt-1 sv-link inline-block" data-testid={"contact-office-email-" + o.city.toLowerCase().replace(/\s/g, '-')}>{o.email}</a>
              </div>
            );
          })}
          <div className="border-t border-gray-200 pt-5"><p className="sv-kicker">Emergencies at sea or in port</p><a href="mailto:operations@sudvik.com" className="sv-mono text-xl mt-1 sv-link inline-block" data-testid="contact-operations-email">operations@sudvik.com</a><p className="text-[15px] text-gray-700 mt-1">Operations desk, monitored 24 hours.</p></div>
        </div>
      </div>
    </div>
  );
}
